import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './root-auth/auth.component';
import { LoginComponent } from './login/login.component';
import { SignupTypeComponent } from './signup-type/signup-type.component';
import { SignupComponent } from './signup/signup.component';
import { ResetComponent } from './reset/reset.component';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { VerifyMobileComponent } from './verify-mobile/verify-mobile.component';
import { InvalidInvitationComponent } from './invalid-invitation/invalid-invitation.component';

const routes: Routes = [
  {
    path: 'reset',
    component: ResetComponent,
  },
  {
    path: 'activate',
    component: VerifyMobileComponent,
  },
  {
    path: 'otp',
    component: OtpVerifyComponent,
  },
  {
    path: 'change-password/:id',
    component: ChangePasswordComponent,
  },
  {
    path: 'verify-email/:id',
    component: VerifyEmailComponent,
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },

      {
        path: 'signup-type',
        component: SignupTypeComponent,
      },
      {
        path: 'signup',
        component: SignupComponent,
      },
      {
        path: 'invalid-invitation',
        component: InvalidInvitationComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
